import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ErrorService, SplittypayError } from 'src/app/core/error.service';
import { Unpaid, UnpaidService } from 'src/app/core/unpaid.service';
import { ERROR_UNPAID_NOT_FOUND } from 'src/app/shared/constants/operationals';

@Component({
  selector: 'app-company-details-unpaid-data',
  templateUrl: './company-details-unpaid-data.component.html',
  styleUrls: ['./company-details-unpaid-data.component.scss'],
})
export class CompanyDetailsUnpaidDataComponent {
  @Input() company_id?: string | null;
  @Output() refresh: EventEmitter<void> = new EventEmitter<void>();
  unpaid?: Unpaid[];
  is_read_running = true;

  constructor(private unpaid_service: UnpaidService, private error_service: ErrorService) {}

  ngOnInit(): void {
    this.unpaid = [];
    if (this.company_id) this.listUnpaid(this.company_id);
  }

  onRefresh(): void {
    this.unpaid = [];
    if (this.company_id) this.listUnpaid(this.company_id);
  }

  listUnpaid(company_id?: string): void {
    this.is_read_running = true;

    if (company_id) {
      this.unpaid_service.listByCompany(company_id).subscribe({
        next: response => {
          this.unpaid = response.data;
          this.is_read_running = false;
        },
        error: error => {
          const processed_error: SplittypayError = this.error_service.preProcessApiError(error);
          if (processed_error.code == ERROR_UNPAID_NOT_FOUND) {
            this.unpaid = [];
          } else {
            this.error_service.processApiError(processed_error.code, processed_error.message);
          }
          this.is_read_running = false;
        },
      });
    }
  }
}
